import { AfterViewInit, Component, inject, input, output, TemplateRef, viewChild } from '@angular/core';

import { NzNotificationDataOptions, NzNotificationService } from 'ng-zorro-antd/notification';

import { ErrorPanelComponent } from './error-panel';
import { HttpApiError } from '@models/api/http-api-error';

@Component({
    selector: 'vz-error-message',
    template: `
        <ng-template let-errors="data">
            @for (err of errors; track $index) {
                <vz-error-panel [error]="err" [border]="false" style="z-index: 99999" />
                @if (!$last) {
                    <span class="layout bc-ll mb025" style="border-bottom: 1px solid; min-height: 8px"></span>
                }
            }
        </ng-template>
    `,
    imports: [ErrorPanelComponent]
})
export class ErrorMessageComponent implements AfterViewInit {

    template    = viewChild(TemplateRef, { read: TemplateRef<any> });
    error       = input.required<HttpApiError | HttpApiError[]>();
    options     = input<NzNotificationDataOptions>();
    dismiss     = output<boolean>();

    private _notification = inject(NzNotificationService);

    ngAfterViewInit(): void {
        let type = 'nt-error';
        const error = this.error();
        const errors = Array.isArray(error) ? error : [error];
        const e = errors[0];
        if (e && e.status == 403 || e.status == 404 || e.status == 409) {
            type = 'nt-info';
        }
        const opts = this.options() || {};
        opts.nzData = errors;
        opts.nzClass = type;
        opts.nzStyle = { 'z-index': '9999' };
        const tpl = this.template();
        if (tpl) {
            const ref = this._notification.template(tpl, opts);
            ref.onClose.subscribe(res => this.dismiss.emit(res));
        }
    }

}
